import { render } from "./chromeGeneral.vue?vue&type=template&id=520524d0"
import script from "./chromeGeneral.vue?vue&type=script&lang=js"
export * from "./chromeGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__